export default "__VITE_ASSET__73SGhAtY__"